import makeStyles from '@mui/styles/makeStyles'
import { borderRadius } from '@mui/system'

export const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  mt: {
    marginTop: '10px',
  },
  appBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#0A688D',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxShadow: '0 0 0 0 #fff',
  },
  indicator: {
    backgroundColor: 'white',
    borderTop: '1px solid #333',
  },
  titleBar: {
    flex: 1,
    flexDirection: 'row',
    alignContent: 'space-between',
  },
  btn: {
    backgroundColor: '#0A688D',
    color: '#fff !important',
    padding: '6px 32px !important',

    '&:hover': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
    '&:focus': {
      outline: '0px !important',
      backgroundColor: '#0A688D',
      color: '#fff',
      // boxShadow: '0 0 0 0.2rem #333',
    },
  },
  disableBtn: {
    backgroundColor: '#797979',
    color: '#fff !important',
    padding: '6px 32px !important',
    disabled: true,
    pointerEvents: 'none',
    cursor: 'default',
    zIndex: '999',
    '&:hover': {
      backgroundColor: '#797979',
    },
  },
  buttonGrey: {
    backgroundColor: '#797979',

    '&:hover': {
      backgroundColor: '#797979',
    },
  },
  mp: {
    margin: 0,
    padding: 0,
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 720,
    background: '#fff',
    border: '2px solid #ccc',
    padding: 20,
    height: '85%',
    overflow: 'hidden',
  },
  table: {
    minWidth: 600,
    background: '#f2f2f2',
  },
  history: {
    marginTop: 10,
  },
  hr: {
    marginTop: 0,
  },
  icon: {
    // color: '#0A688D'
  },
  errorIcon: {
    color: '#f00',
  },
  actionView: {
    flex: 1,
    flexDirection: 'row',
    width: '100px',
    textAlign: 'center',
  },
  anchor: {
    textDecoration: 'none',
    color: '#0A688D',
  },
  alignRight: {
    bottom: '10px',
    position: 'absolute',
    right: '20px',
    textAlign: 'right',
  },
  tableBody: {
    background: '#fff',
  },
  container: {
    flex: 1,
    display: 'block',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '20px',
    marginBottom: '10px',
  },
  mb: {
    marginBottom: '10px',
  },
  sendIcon: {
    fontSize: '26px',
    margin: '0 0.2rem',
  },
  receiveSlidesButton: {
    left: '336px',
  },
  buttonMargin: {
    marginLeft: '10px',
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'left',
  },
  discardDialogHeight: {
    height: '180px',
  },
  discardDialogContent: {
    display: 'flex',
    justifyContent: 'left',
    marginTop: '20px',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'row',
  },
  card: {
    minWidth: 100,
    margin: '0px 15px 10px 15px',
  },
  buttonActions: {
    width: '100%',
    bottom: '0',
    left: '0',
    borderTop: '1px solid #ccc',
    background: '#fff',
    zIndex: '999',
  },
  contentDetails: {
    fontWeight: 'bold',
  },
  dialogHeight: {
    overflowY: 'hidden',
  },
  dialogOverflow: {
    overflow: 'visible',
  },
  dialogContentBox: {
    overflowY: 'visible',
  },
  hrBottom: {
    position: 'absolute',
    width: '676px',
    bottom: '45px',
  },
  dialogTitle: {
    backgroundColor: '#0A688D',
    color: '#FFF',
  },
  closeSearch: {
    marginLeft: '228px',
    position: 'absolute',
    marginTop: '-40px',
    cursor: 'pointer',
    color: '#0A688D',
  },
  searchTitle: {
    color: '#0A688D',
  },
  loadBalancer: {
    // position: 'absolute',
    // marginLeft: '675px',
    width: '740px',
    marginTop: '-5px',
  },
  pathologistLoadBalancer: {
    width: '1078px',
    marginTop: '-5px',
  },
  loadingIndicator: {
    width: '40px',
    marginLeft: '320px',
    marginTop: '-50px',
    height: '40px',
    position: 'absolute',
  },
  warningIcon: {
    color: 'rgba(0, 0, 0, 0.6)',
    marginLeft: '35px',
    marginTop: '-30px',
  },
  caseIdDiv: {
    display: 'flex',
    alignItems: 'center',
  },
  caseIdIcon: {
    marginTop: '10px',
    marginLeft: '2px',
  },
  chipSpacing: {
    marginRight: '5px',
  },
  filter: {
    // '& .MuiDataGrid-filterForm': { p: 2, display: 'block', width: 'fit-content' },
    // '& .MuiDataGrid-filterForm:nth-child(even)': {},
    // '& .MuiDataGrid-filterFormLinkOperatorInput': { mr: 2 },
    // '& .MuiDataGrid-filterFormColumnInput': { mr: 2, width: 150 },
    // '& .MuiDataGrid-filterFormOperatorInput': { mr: 2 },
    // '& .MuiDataGrid-filterFormValueInput': { width: 'fit-content' },
  },
})
